import Alert from "@mui/material/Alert";

export default function FinanceiroEmptyState() {
  return (
    <Alert severity="info" sx={{ mb: 2 }}>
      Nenhum dado financeiro encontrado para o período selecionado.
    </Alert>
  );
}
